import dayjs from 'dayjs'

import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('views.calling_sessions.view_all_supporters.callback')

export const FLEXIBLE_WINDOW_MINUTES = 60

export function relativeDay(iso: string, now: Date) {
  const diff = Math.round((dayjs(iso).startOf('day').valueOf() - dayjs(now).startOf('day').valueOf()) / 86_400_000)
  if (diff === 0) return t('today')
  if (diff === 1) return t('tomorrow')
  if (diff === -1) return t('yesterday')
  return null
}

const dayLabel = (iso: string, now: Date) => relativeDay(iso, now) ?? dayjs(iso).format('ddd D MMM')

export function timeRange(iso: string, flexible: boolean) {
  const start = dayjs(iso)
  if (!flexible) return start.format('h:mm A')
  const end = start.add(FLEXIBLE_WINDOW_MINUTES, 'minute')
  const sameHalf = start.format('A') === end.format('A')
  return `${start.format(sameHalf ? 'h:mm' : 'h:mm A')} – ${end.format('h:mm A')}`
}

export const whenRange = (iso: string, now: Date, flexible: boolean) =>
  `${dayLabel(iso, now)}, ${timeRange(iso, flexible)}`
export const whenLabel = (iso: string, now: Date) => whenRange(iso, now, false)
